import { getSelectedGroupId } from './session';

const axios = require('axios');

// The login comes from the access token; group_id picks which of its groups the call is for.
const getConfig = ({ withGroup = true } = {}) => {
    const headers = {
        "access-token": localStorage.getItem('access-token'),
        'pubid': localStorage.getItem('pub_id'),
        'role_id': localStorage.getItem('role_id')
    };
    const groupId = getSelectedGroupId();
    if (withGroup && groupId) {
        headers.group_id = groupId;
    }
    return { headers };
};

// Failed responses may carry { message } or a plain string body; always resolve to { success: false, status, message }.
const handleError = (error) => {
    const data = error.response && error.response.data;
    const message = (data && data.message) || (typeof data === 'string' && data) || 'Something went wrong ! try again';
    return { success: false, status: error.response ? error.response.status : null, message };
};

const get = (path, options) => axios
    .get(process.env.REACT_APP_API_SERVER_HOST + path, getConfig(options))
    .then((response) => response.data)
    .catch(handleError);

const post = (path, body) => axios
    .post(process.env.REACT_APP_API_SERVER_HOST + path, body, getConfig())
    .then((response) => response.data)
    .catch(handleError);

const getGroups = () => get('/corporateGroup/groups', { withGroup: false });

const getSummary = () => get('/corporateGroup/summary');

const getMembers = () => get('/corporateGroup/members');

// payload: { employee_id, name, email, membership_end_date }
const addMember = (payload) => post('/corporateGroup/member/add', payload);

const updateMember = (memberId, payload) => post('/corporateGroup/member/update', { member_id: memberId, ...payload });

const removeMember = (memberId) => post('/corporateGroup/member/remove', { member_id: memberId });

const resendWelcome = (memberId) => post('/corporateGroup/member/resend-welcome', { member_id: memberId });

// 403 for a group this login no longer manages: pick another group and reload.
export const isGroupAccessError = (response) =>
    response && response.status === 403 && /don't have access to this group/i.test(response.message || '');

// 401, or 403 once the login has no groups left: the session is over.
export const isSessionEndedError = (response) =>
    response && (response.status === 401 || (response.status === 403 && /access to this group has been removed/i.test(response.message || '')));

export const service = {
    getGroups,
    getSummary,
    getMembers,
    addMember,
    updateMember,
    removeMember,
    resendWelcome,
};
